import { render, staticRenderFns } from "./TicketsTypesView.vue?vue&type=template&id=fae3ae96&scoped=true"
import script from "./TicketsTypesView.vue?vue&type=script&lang=js"
export * from "./TicketsTypesView.vue?vue&type=script&lang=js"
import style0 from "./TicketsTypesView.vue?vue&type=style&index=0&id=fae3ae96&prod&lang=scss&scoped=true"
import style1 from "./TicketsTypesView.vue?vue&type=style&index=1&id=fae3ae96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae3ae96",
  null
  
)

export default component.exports